var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.disableButton
        ? _c(
            "button",
            {
              staticClass: "button is-outlined",
              class: {
                "is-success ": _vm.appliedFilterCount > 0,
                "is-cancel": _vm.appliedFilterCount == 0,
              },
              on: {
                click: () => (_vm.isCollapsed ? _vm.onShow() : _vm.onHide()),
              },
            },
            [
              _c(
                "span",
                { staticClass: "icon" },
                [_c("Icon", { attrs: { name: "Filters" } })],
                1
              ),
              _vm._v(" "),
              _vm.appliedFilterCount
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.appliedFilterCount) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Portal", [
        _c(
          "div",
          {
            ref: _vm.idMenu,
            class: [
              "asideMenu " + _vm.classes,
              _vm.idMenu,
              { collapsed: _vm.isCollapsed },
            ],
            style: { width: `${_vm.width}px` },
            attrs: { id: _vm.idMenu },
            on: { mouseleave: _vm.onLeave },
          },
          [
            _c(
              "div",
              { staticClass: "inner", staticStyle: { overflow: "hidden" } },
              [
                _vm.enableResize
                  ? [
                      _c("div", {
                        ref: `resizer.${_vm.idMenu}`,
                        staticClass: "resizer",
                        on: { mousedown: _vm.onResizerDown },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-1" },
                  [
                    _vm.showHeader
                      ? _c(
                          "div",
                          { staticClass: "header v-center" },
                          [
                            _vm.appliedFilterCount
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "tag tag-filtercount mr5-xs",
                                    class: {
                                      "is-success": _vm.appliedFilterCount > 0,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.appliedFilterCount))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("header"),
                            _vm._v(" "),
                            _c("div", { staticClass: "ml-auto" }),
                            _vm._v(" "),
                            _vm.enablePin
                              ? [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-outlined is-small",
                                      on: { click: _vm.onHide },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon" },
                                        [
                                          _c("Icon", {
                                            attrs: { name: "UnPin" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "on-collapsed" }, [
                      _c(
                        "span",
                        {
                          staticClass: "tag",
                          class: { "is-success": _vm.appliedFilterCount > 0 },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.appliedFilterCount) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._t("default"),
                  ],
                  2
                ),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _vm.showOverlay
          ? _c("div", {
              staticClass: "asideMenu-Overlay",
              on: { click: _vm.collapseMenu },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }